import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiLink2, FiHexagon, FiBookOpen, FiBriefcase, FiCompass, FiGrid, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { FaRegChartBar } from 'react-icons/fa';
import { HiOutlineDocumentText, HiOutlineAcademicCap } from 'react-icons/hi';
import * as utils from '../../utils/utils';
import styles from './Sidebar.module.css';

const navigationItems = [
	{
		label: 'Dashboard',
		to: '/dashboard',
		exact: true,
		icon: FiGrid,
	},
	{
		label: 'Log Live-Resume',
		to: '/live-resume',
		exact: true,
		icon: HiOutlineDocumentText,
	},
	{
		label: 'Stream',
		to: '/stream',
		exact: true,
		icon: FiCompass,
	},
	// {
	// 	label: 'Learn',
	// 	to: '/learn',
	// 	exact: true,
	// 	icon: HiOutlineAcademicCap,
	// },
	{
		label: 'Ask',
		to: '/ask',
		exact: true,
		icon: FiHexagon,
	},
	{
		label: 'Intros',
		to: '/intros',
		exact: true,
		icon: FiLink2,
	},
	// {
	// 	label: 'Explore',
	// 	to: '/explore',
	// 	exact: true,
	// 	icon: FiCompass,
	// },
	// {
	// 	label: 'Jobs Center',
	// 	to: '/jobs-center',
	// 	exact: true,
	// 	icon: FiBriefcase,
	// },
	// {
	// 	label: 'My Courses',
	// 	to: '/my-courses',
	// 	exact: true,
	// 	icon: FiBookOpen,
	// },
	// {
	// 	label: 'Competency Matrix',
	// 	to: '/competency-matrix',
	// 	exact: true,
	// 	icon: FaRegChartBar,
	// },
];

export default function Sidebar() {
	const [isOpen, setIsOpen] = useState(false);
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	const closeSidebar = () => {
		setIsOpen(false);
	};

	const toggleSidebar = () => {
		setIsOpen((currentValue) => !currentValue);
	};

	const onLogoutClick = async () => {
		if (isLoggingOut) {
			return;
		}

		setIsLoggingOut(true);

		try {
			await utils.sendRequest('/auth/logout', {});
		} catch (error) {
			console.log('sidebar logout error', error);
		}

		utils.removeAuthDetails();
		window.location.href = '/';
	};

	return (
		<>
			<button
				type='button'
				className={styles.toggleButton}
				onClick={toggleSidebar}
				aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
				aria-expanded={isOpen}
			>
				{isOpen ? <FiX /> : <FiMenu />}
			</button>

			<div
				className={`${styles.backdrop} ${isOpen ? styles.backdropVisible : ''}`}
				onClick={closeSidebar}
				aria-hidden={!isOpen}
			/>

			<aside className={`${styles.sidebarShell} ${isOpen ? styles.sidebarOpen : ''}`}>
				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.sidebarContent}>
					<div className={styles.brandBlock}>
						<div className={styles.logoBadge}>HQVibe</div>
						<p className={styles.brandEyebrow}>Career Intelligence Workspace</p>
						<h1 className={styles.brandTitle}>Professional momentum, organized.</h1>
						<p className={styles.brandText}>
							Navigate your dashboard, live-resume workflow, and growth surfaces from one focused control panel.
						</p>
					</div>

					<nav className={styles.nav} aria-label='Primary'>
						{navigationItems.map((item) => {
							const Icon = item.icon;

							return (
								<NavLink
									key={item.to}
									to={item.to}
									exact={item.exact}
									className={styles.navLink}
									activeClassName={styles.navLinkActive}
									onClick={closeSidebar}
								>
									<span className={styles.iconWrap}>
										<Icon />
									</span>

									<span className={styles.linkText}>{item.label}</span>
								</NavLink>
							);
						})}

						<button
							type='button'
							className={`${styles.logoutButton} ${isLoggingOut ? styles.logoutButtonDisabled : ''}`}
							onClick={onLogoutClick}
							disabled={isLoggingOut}
						>
							<span className={styles.iconWrap}>
								<FiLogOut />
							</span>
							<span className={styles.linkText}>{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
						</button>
					</nav>
				</div>
			</aside>
		</>
	);
}
